import { Injectable } from '@angular/core';

import { ApiService } from '@/api';
import { District } from '@/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DistrictsService {

    constructor(private apiService: ApiService) {
    }

    edit(id: string, data: Record<string, any>): Observable<District> {
        return this.apiService.patch<District>(`/districts/${id}`, data)
            .pipe(map(response => response.data));
    }

    autocomplete(field: string, query: string) {
        return this.apiService.get<{ label: string; value: string }[]>(`/districts/autocomplete/${field}`, { q: query });
    }
}
